import React, { useEffect, useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje } from '../mensajes2';
import { Dimmer } from '../spinner';

import useTable from "../useTable"
import Controls from "../controls/Controls";

import { TableBody, TableRow, TableCell, InputAdornment } from '@mui/material'

    ;

import axios from 'axios';
import { validaMonto, formatoMonto, validaSoloNumero, formatMoneda, seleccionarCampo } from '../../util/varios';
import moment from 'moment';


const AgregarTipoConstruccion = props => {

    /*  variables de estados */

    let op = require('../../../src/modulos/datos');
    const anioactu = JSON.parse(localStorage.getItem('anioactu'));

    let token = localStorage.getItem('jwtToken');
    const txtValorPetro = useRef();
    const txtDescrip = useRef();
    const txtValorBs = useRef();
    const txtCantidad = useRef();
    const txtValorPrivado = useRef();
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtSector = useRef();
    const txtApendice = useRef();
    const txtValorMuni = useRef();

    const txtValorActualP = useRef();
    const txtValorActualB = useRef();


    const [mostrar, setMostrar] = useState(false);
    const [labels, setLabels] = useState('Bs/m2')
    const [titulo, setTitulo] = useState();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [values, setValues] = useState({
        idvalorterreno: '',
        apendice: '',
        sector: '',
        descripcion: '',
        valor: '',
        valorpriv: '',
        rural: 0,

    })
    const [msg, setMsg] = useState();
    const [activate, setActivate] = useState(false);
    const [activo, setActivo] = useState(true);
    const [operacion, setOperacion] = useState('0');
    const [operacionFicha, setOperacionFicha] = useState('0');

    const blanquear = () => {
        setValues({
            idvalorterreno: '',
            apendice: '',
            sector: '',
            descripcion: '',
            valor: '',
            valorpriv: '',
            rural: 0,

        })
    }

    const cerrarModal = () => {

        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
        props.render(props.idAval)
        props.onHideCancela();
    }

    const cancelar = () => {

        props.onHideCancela()

        blanquear()

    }



    const procesarConstruccion = () => {
        console.log(props.operacion);
        let endpoint;

        if (props.operacion === 1) {
            endpoint = `${op.conexion}/api/catastro/actualizarconstruccion`;
        } else {
            endpoint = `${op.conexion}/api/catastro/updateconstruccion`;
        }


        let body;


        body = {
            operacion: props.operacion,
            nid: props.opracion === 1 ? 0 : props.idDetalle,
            idAva: props.idAval,
            idTipo: props.dataInmueble.idtipoinmueble,
            nvalorm2: txtCantidad.current.value.replace(/\./g, '').replace(',', '.'),
            narea: txtValorPetro.current.value.replace(/\./g, '').replace(',', '.'),
            nporce: '3.00',
            nvalor: txtValorActualP.current.value.replace(/\./g, '').replace(',', '.'),
            nanio: anioactu,
            cestado: 'EXCCELNTE',
            descr: txtDescrip.current.value
        };

        console.log(body);

        axios
            .post(endpoint, body, {
                headers: {
                    "x-access-token": `${token}`,
                },
            })
            .then(function (response) {
                if (response.status == 200) {
                    if (operacion === 1) {

                        setMensaje({
                            mostrar: true,
                            titulo: "Exito.",
                            texto: "Registro Registrado Exitosamente",
                            icono: "exito",
                        });
                    } else if (operacion === 2) {

                        setMensaje({
                            mostrar: true,
                            titulo: "Exito.",
                            texto: "Registro Modificado Exitosamente",
                            icono: "exito",
                        });
                    } else if (operacion === 3) {
                        setMensaje({
                            mostrar: true,
                            titulo: "Exito.",
                            texto: "Registro Eliminado Exitosamente",
                            icono: "exito",
                        });
                    }

                }
                setActivate(false);
            })
            .catch(function (error) {
                setMensaje({
                    mostrar: true,
                    titulo: "ERROR",
                    texto: error.response.data.message,
                    icono: "error",
                });

                setActivate(false);
            });




    };


    const onChangeValidar = (e) => {
        e.preventDefault()
        let sigue = true;


        if (txtCantidad.current.value === '') {

            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Ingresar la Cantidad', icono: 'informacion' })
            sigue = false;
            txtCantidad.current.focus();

        }




        if (sigue) {
            props.agregar({
                iddetalleconstruccionavaluo: 0,
                idtipologia: 1,
                descrip: txtDescrip.current.value,
                valormt2: txtCantidad.current.value.replace(/\./g, '').replace(',', '.'),
                areaconstruccion: txtValorPetro.current.value.replace(/\./g, '').replace(',', '.'),
                porcentajedepre: '3.00',
                valor: txtValorActualP.current.value.replace(/\./g, '').replace(',', '.')
            })

            /*if(props.operacionAvaluo === 1){
                props.agregar({
                    descrip:txtDescrip.current.value,
                    valormt2:txtCantidad.current.value.replace(/\./g, '').replace(',', '.'),
                    areaconstruccion:txtValorPetro.current.value.replace(/\./g, '').replace(',', '.'),
                    porcentajedepre:'3.00',
                    valor:txtValorActualP.current.value.replace(/\./g, '').replace(',', '.')
                })
            } else{
                procesarConstruccion()
            }*/



        }


    }

    const handleInputMontoChange = (event) => {
        validaMonto(event);
        if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
            event.target.value = '0,00'
        }
        if (event.which >= 37 && event.which <= 40) {
            event.preventDefault();
        }
        let char1 = event.target.value.substring(0, 1);
        let char2 = event.target.value.substring(1, 2);
        if (char1 === '0' && char2 !== ',') {
            event.target.value = event.target.value.substring(1, event.target.value.legth);
        }
        if (event.which === 13 || typeof (event.which) === 'undefined'){
            console.log(event.target.value.replace(/\./g, "").replace(",", "."))
            let actualP = parseFloat(event.target.value.replace(/\./g, "").replace(",", ".")) * parseFloat(txtValorPetro.current.value.replace(/\./g, "").replace(",", "."));
            let actualB = parseFloat(event.target.value.replace(/\./g, "").replace(",", ".")) * parseFloat(txtValorBs.current.value.replace(/\./g, "").replace(",", "."))

            txtValorActualP.current.value = formatMoneda(actualP.toString().replace(".", ","), ",", ".", 2);
            txtValorActualB.current.value = formatMoneda(actualB.toString().replace(".", ","), ",", ".", 2);
            btnAcepta.current.focus();
        }
        

        // Devuelve el número formateado
        let e = event.target.value.replace(/\D/g, "")
            .replace(/([0-9])([0-9]{2})$/, '$1.$2')
            .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");

        return formatMoneda(e)
    };




    console.log(values)

    const handleInputNumChange = (event) => {
        //setActiveIndex(1);
        validaSoloNumero(event);
        if (event.which === 13 || typeof (event.which) === 'undefined') {


        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;//alert(e.which);
    };

    const seleccionarTipoInmueble = (data) => {

        let endpoint = `${op.conexion}/api/catastro/tipoinmueble?idtipoinmueble=${data.idtipoinmueble}&idclaseinmueble=${data.idclaseinmueble}`;
        console.log(endpoint);
        /*       setActivate(true); */

        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                },
            })
            .then(function (response) {
                if (response.status == 200) {

                    if (response.data.length > 0) {
                        console.log(response.data)
                        txtDescrip.current.value = response.data[0].descrip.trim();
                        txtValorPetro.current.value = formatMoneda(response.data[0].valor.toString().replace(".", ","), ",", ".", 2)
                        let valorBs = parseFloat(response.data[0].valor) * parseFloat(props.valorPetro)
                        txtValorBs.current.value = formatMoneda(valorBs.toString().replace(".", ","), ",", ".", 2)
                    }
                    setActivate(false)

                }


            })
            .catch((error) => {
                setMensaje({
                    mostrar: true,
                    titulo: "ERROR",
                    texto: error.response.data.message,
                    icono: "error",
                });

                setActivate(false);
            });
    };





    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{
                backgroundColor: 'rgba(0, 0, 0, 0.521)'
            }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                setOperacion(props.operacion)
                seleccionarTipoInmueble(props.dataInmueble);
                if (props.operacion !== 1) {
                    txtCantidad.current.value = formatMoneda(props.cantidad.valormt2.toString().replace(".", ","), ",", ".", 2)
                    let actualP = parseFloat(props.cantidad.valormt2.replace(/\./g, "").replace(",", ".")) * parseFloat(txtValorPetro.current.value.replace(/\./g, "").replace(",", "."));
                    let actualB = parseFloat(props.cantidad.valormt2.replace(/\./g, "").replace(",", ".")) * parseFloat(txtValorBs.current.value.replace(/\./g, "").replace(",", "."))


                    txtValorActualP.current.value = formatMoneda(actualP.toString().replace(".", ","), ",", ".", 2);
                    txtValorActualB.current.value = formatMoneda(actualB.toString().replace(".", ","), ",", ".", 2);
                } else {
                    txtCantidad.current.value = "0,00"
                }
                txtCantidad.current.focus();

                /*   if (props.operacion !== 1) {
                      setValues(props.tierra)
                  } */

            }}
        >
            <Modal.Header className='azulGradiant'>
                <Modal.Title style={{ color: "#fff" }}>
                    {operacion === 1 ? 'Agregar Valor de Terreno' : operacion === 2 ? 'Editar Valor de Terreno' : operacion === 3 ? 'Eliminar Valor de Terreno' : 'Consultar Valor de Terreno'} </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Mensaje mensaje={mensaje}
                    onHide={() => {
                        mensaje.titulo === 'Exito.' ?
                            cerrarModal() :
                            setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                    }
                    } />
                <Dimmer active={activate} inverted>

                </Dimmer>

                <div className='row col-md-12 mx-auto px-0'>

                    <fieldset className=' row col-md-12 mt-2 mb-3 border-azul row rounded mx-auto d-flex justify-content-between'>
                        <legend className="float-none w-auto" >Detalle de la Construcción</legend>


                        <div className="input-group input-group-sm mb-2 col-md-12">
                            <span className="input-group-text" id="inputGroup-sizing-sm">Descripción:</span>
                            <input type="text" className="form-control text-uppercase" ref={txtDescrip} disabled aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" name='idvalorterreno' />
                        </div>

                        <div className='col-md-4'></div>

                        <div className="input-group input-group-sm mb-2 col-md-4">
                            <span className="input-group-text" id="inputGroup-sizing-sm">Valor UC:</span>
                            <input type="text" className="form-control text-right" ref={txtValorPetro} disabled aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" name='idvalorterreno' />
                        </div>
                        <div className="input-group input-group-sm mb-2 col-md-4">
                            <span className="input-group-text" id="inputGroup-sizing-sm">Valor Bs:</span>
                            <input type="text" className="form-control text-right" ref={txtValorBs} disabled aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" name='idvalorterreno' />
                        </div>
                        <div className='col-md-8'></div>
                        <div className="input-group input-group-sm mb-2 col-md-4">
                            <span className="input-group-text" id="inputGroup-sizing-sm">Cantidad(m2):</span>
                            <input type="text" className="form-control text-right"autoComplete='off' ref={txtCantidad} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" name='cantidad'  onFocus={seleccionarCampo} onBlur={handleInputMontoChange} onKeyUp={handleInputMontoChange} /*onChange={handleInputMontoChange}*/ />
                        </div>

                        <div className="input-group input-group-sm mb-2 col-md-6">
                            <span className="input-group-text bg-transparent border-0" id="inputGroup-sizing-sm">Valor ActuaL UC:</span>
                            <input type="text" className="form-control text-right bg-transparent border-0 fw-bold" disabled ref={txtValorActualP} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" name='idvalorterreno' />
                            {/*   <span className="input-group-text bg-transparent border-0" id="inputGroup-sizing-sm">PTR.</span> */}

                        </div>
                        <div className="input-group input-group-sm mb-2 col-md-6">
                            <span className="input-group-text bg-transparent border-0" id="inputGroup-sizing-sm">Valor Actual Bs:</span>
                            <input type="text" className="form-control text-right bg-transparent border-0 fw-bold" disabled ref={txtValorActualB} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" name='idvalorterreno' />
                            <span className="input-group-text bg-transparent border-0" id="inputGroup-sizing-sm">Bs.</span>

                        </div>

                    </fieldset>






                </div>

            </Modal.Body>
            <Modal.Footer>
                <button ref={btnAcepta} className="btn btn-sm btn-success rounded-pill" onClick={onChangeValidar}><i className="fas fa-check-circle"> Aceptar</i> </button>

                <button ref={btnCancela} onClick={cancelar} className="btn btn-danger btn-sm rounded-pill"><i className="fa"> Cancelar</i></button>

            </Modal.Footer>
        </Modal>
    );
}

export default AgregarTipoConstruccion;